import script from "./TocContentTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./TocContentTabs.vue?vue&type=script&setup=true&lang=ts"

import "./TocContentTabs.vue?vue&type=style&index=0&id=b79479fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b79479fe"]])

export default __exports__